// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_M3s","cls2":"UpsellModalRedesign-cls2_0qE UpsellModalRedesign-cls1_M3s"};